/* Vidéos du thème (snippets/video.liquid + blocks/video.liquid) — un seul fichier, mis en cache, chargé en différé
   UNE fois par page (layout/theme.liquid, marque <!--js:hz-video-->). ES5, compatible iOS 12.
   1. Chargement différé : <video data-video-differee> (vidéo envoyée dans Shopify ou lien MP4) n'a ni source
      (<source data-src>) ni affiche (data-poster) au départ. À 400 px de l'écran : affiche + source posées,
      preload="metadata", lecture si autoplay. Sans IntersectionObserver : tout de suite.
   2. Lecteur des liens MP4 ([data-video-mp4]) : clic / Entrée = lecture-pause, bouton lecture quand la vidéo
      est en pause, réduction des animations respectée. */
(function () {
  if (window.__hzVideo) {
    if (window.__videoDifferee) window.__videoDifferee();
    return;
  }
  window.__hzVideo = true;

  var calme = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var obs = null;
  var prevu = false;

  function cadre(v) {
    var p = v && v.parentNode;
    return p && p.hasAttribute && p.hasAttribute('data-video-mp4') ? p : null;
  }
  function ajouterClasse(el, c) {
    if (el && (' ' + el.className + ' ').indexOf(' ' + c + ' ') < 0) el.className += ' ' + c;
  }

  /* Lien MP4 en lecture auto : si elle n'a pas démarré 2,5 s après son activation, on montre le bouton lecture. */
  function surveiller(v) {
    var c = cadre(v);
    if (!c || !v.autoplay) return;
    setTimeout(function () {
      if (v.paused) ajouterClasse(c, 'video-mp4--pause');
    }, 2500);
  }

  function activer(e) {
    if (!e || e.__vdOk) return;
    e.__vdOk = 1;
    if (obs) obs.unobserve(e);
    var affiche = e.getAttribute('data-poster');
    if (affiche) {
      e.setAttribute('poster', affiche);
      e.removeAttribute('data-poster');
    }
    var sources = e.getElementsByTagName('source');
    var change = false;
    for (var i = 0; i < sources.length; i++) {
      var u = sources[i].getAttribute('data-src');
      if (u) {
        sources[i].setAttribute('src', u);
        sources[i].removeAttribute('data-src');
        change = true;
      }
    }
    e.setAttribute('preload', 'metadata');
    if (change) {
      try { e.load(); } catch (x) {}
    }
    if (e.autoplay) {
      try {
        var p = e.play();
        if (p && p.catch) p.catch(function () {});
      } catch (x) {}
    }
    surveiller(e);
  }

  if ('IntersectionObserver' in window) {
    obs = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting || entrees[i].intersectionRatio > 0) activer(entrees[i].target);
      }
    }, { rootMargin: '400px 0px 400px 0px' });
  }

  /* Liens MP4 : réduction des animations = pas de lecture auto, contrôles visibles. */
  function preparerMp4() {
    var vs = document.querySelectorAll('[data-video-mp4] > video');
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.__pret) continue;
      v.__pret = true;
      if (calme) {
        v.removeAttribute('autoplay');
        v.autoplay = false;
        try { v.pause(); } catch (x) {}
        v.controls = true;
        ajouterClasse(cadre(v), 'video-mp4--pause');
        ajouterClasse(cadre(v), 'video-mp4--calme');
      } else if (!v.hasAttribute('data-video-differee')) {
        surveiller(v);
      }
    }
  }

  function scanner() {
    prevu = false;
    preparerMp4();
    var l = document.querySelectorAll('video[data-video-differee]');
    for (var i = 0; i < l.length; i++) {
      var v = l[i];
      if (v.__vdVu || v.__vdOk) continue;
      v.__vdVu = 1;
      if (obs) obs.observe(v);
      else activer(v);
    }
  }
  function bientot() {
    if (prevu) return;
    prevu = true;
    setTimeout(scanner, 250);
  }

  window.__videoDifferee = scanner;
  window.__videoDiffereeActiver = function (e) {
    if (e && e.hasAttribute && e.hasAttribute('data-video-differee')) activer(e);
  };

  function basculer(v) {
    if (!v || v.controls) return;
    if (v.hasAttribute('data-video-differee') && !v.__vdOk) activer(v);
    if (v.paused) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } else v.pause();
  }
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('[data-video-mp4]') : null;
    if (c) basculer(c.querySelector('video'));
  });
  document.addEventListener('keydown', function (e) {
    var v = e.target;
    if (v && v.tagName === 'VIDEO' && cadre(v) && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) {
      e.preventDefault();
      basculer(v);
    }
  });
  function etat(e) {
    var c = cadre(e.target);
    if (!c) return;
    if (e.type === 'play') c.className = c.className.replace(/\s*video-mp4--pause/g, '');
    else ajouterClasse(c, 'video-mp4--pause');
  }
  document.addEventListener('play', etat, true);
  document.addEventListener('pause', etat, true);

  scanner();
  document.addEventListener('DOMContentLoaded', scanner);
  window.addEventListener('load', scanner);
  document.addEventListener('shopify:section:load', bientot);
  document.addEventListener('scroll', bientot, { capture: true, passive: true });
  document.addEventListener('touchstart', bientot, { capture: true, passive: true });
})();
